module.exports = __webpack_public_path__ + "static/img/aboutAc.ff0734b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutAc.svg
// module id = NMLv
// module chunks = 1